import type { TFunction } from 'i18next';

import { VisibilityType } from 'src/utils/app_visibility';

/**
 * Visibility option labels for settings surfaces. Classic keeps the historical
 * "all contacts" wording; Studio uses the Figma "everyone" copy.
 */
export const getAppVisibilityOptionLabel = (
  type: VisibilityType,
  t: TFunction,
  isStudioPricingWorkspace: boolean,
): string => {
  if (isStudioPricingWorkspace) {
    switch (type) {
      case VisibilityType.VisibleToEveryone:
        return t(
          ($) =>
            $.page_apps.client_facing_app_visibility.studio_subtitle
              .all_clients,
        );
      case VisibilityType.NoVisibility:
        return t(
          ($) => $.page_apps.client_facing_app_visibility.studio_subtitle.none,
        );
      case VisibilityType.CustomVisibility:
        return t(
          ($) =>
            $.page_apps.client_facing_app_visibility.studio_subtitle.custom,
        );
    }
  }

  switch (type) {
    case VisibilityType.VisibleToEveryone:
      return t(
        ($) => $.page_apps.client_facing_app_visibility.subtitle.all_clients,
      );
    case VisibilityType.NoVisibility:
      return t(($) => $.page_apps.client_facing_app_visibility.subtitle.none);
    case VisibilityType.CustomVisibility:
      return t(($) => $.page_apps.client_facing_app_visibility.subtitle.custom);
  }
};
